import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from './useUser';
import { User } from './user';
import { useLoginAction } from './authActions';
import { useIsUnityAuthenticated } from './useIsUnityAuthenticated';

/**
 * Hook that provides a returnTo string for the current location
 */
export function useCurrentPageReturnTo() {
  const { pathname, search, hash } = useLocation();

  return { pathname, search, hash };
}

/**
 * Hook used on routes that require a logged in user to ensure that the user is logged in
 * Note that due to potential async requirements and the lack of Suspense the return value needs
 * to be checked for a null-ish value to account for a loading state.
 * Returning null from the render under that situation should be acceptable.
 * @see {@link useUser}
 */
export function useAuthedUser(): User | null {
  const isAuthenticated = useIsUnityAuthenticated();
  const user = useUser();
  const login = useLoginAction();
  if (isAuthenticated) {
    return user;
  } else {
    login();
    return null;
  }
}
